<template>
  <v-app>
    <v-container fluid>
      <v-container fluid>
        <vue-core-video-player id="myVideo" :src="require('@/assets/demo/Studio_Project_V4.mp4')" ref="videoRef"
          disablePictureInPicture autoplay loop muted playsinline style="pointer-events: none;"></vue-core-video-player>

        <div class="content">
          <div class="text">
            <h1 class="hidden-sm-and-down">Welcome to JH-Y Kitchen Cabinet</h1>
            <div><v-img :src="require('../assets/transparent_logo.png')" contain max-height="100"></v-img></div>
            <br/>
            <div><v-btn id="myBtn" outlined dark color="#9e8665" @click="goto('/home')">Enter</v-btn></div>

          </div>

        </div>

      </v-container>

    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'Facade',
  mounted: function () {
    this.$refs.videoRef.play()
  },
  data: () => ({
    title: "Pause Video",
  }),
  methods: {
    goto(routerName) {
      if (this.$route.name !== routerName) {
        this.$router.push({
          name: routerName
        })
      }
    },
    async myFunction() {
      // console.log(JSON.stringify(this.$refs.videoRef.status))
      if (this.$refs.videoRef.paused) {
        // this.$refs.videoRef.play();
        // this.title = "Pause Video";
      } else {
        // this.$refs.videoRef.pause();
        // this.title = "Play Video";
      }
    }
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: Arial;
  font-size: 17px;
}

#myVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}

.content {
  position: fixed;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #9e8665;
  width: 100%;
  height: 100%;
  text-align: center;
  /* padding: 400px; */
}

.text {
  position: fixed;
  right: 10%;
  top: 50%;
  width: 80%;
  text-align: center;
  /* margin: auto; */
  background: rgba(46, 60, 82, 0.6);
  color: #9e8665;
  padding: 40px;
}

#myBtn {
  width: 200px;
  font-size: 18px;
  padding: 10px;
  background: #2e3c52;
  color: #9e8665;
  cursor: pointer;
  border: 2px solid #9e8665;
}


#myBtn:hover {
  background: #9e8665;
  color: #2e3c52 !important;
  border: 2px solid #2e3c52;
}
</style>
